import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding: 0 16px 16px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
`;

export const CommentSectionWrapper = styled.div<{ $emptyComments: boolean }>`
  flex-grow: 1;
  flex: 1;
  width: 100%;
  height: calc(100vh - 150px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${({ $emptyComments }) => ($emptyComments ? 'center' : 'flex-start')};
  overflow-y: auto;
  align-self: stretch;
`;
